export enum ApplicationProductPlanEnum {
  FREE = "FREE",
  PAID = "PAID",
  CUSTOM = "CUSTOM",
}
